import i18n from '../_i18n';
import moment from "moment";
import { languages } from './languages';
import { store } from "../stores/store";
import { types } from "../actions/types"


function _getGenderLetter(gender_id) {
  switch (gender_id) {
    case 1:
      return "m";
    case 2:
      return "f";
    default:
      return "";
  }
}


const _setLanguage = (language) => {
  i18n.changeLanguage(language.code);

  store.dispatch({
    type: types.updateLanguage,
    payload: language,
  });
};


const deleteCookie = (name) => {
  document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

const deleteSessionCookie = () => deleteCookie('connect.sid');

const deleteSession = () => {
  localStorage.removeItem('lang');
  localStorage.removeItem('nutritionProfile');
  localStorage.removeItem('userSession');
  deleteSessionCookie();
};


//todo: implement global state w/library
const getNutritionProfile = () => {
    const { auth } = store.getState();
    const { user, nutritionalProfile } = auth;

    const clonedProfile = { ...nutritionalProfile };
    let gender = '';
    let age = 0;
    let foodPreference = 1;
    let foodPathologies = [];
    let foodAllergies = [];
    let foodIntolerances = [];

    if (Object.keys(user).length > 0) {
        const {
            gender_id,
            birthday,
            food_preference_id,
            pathologies,
            allergies,
            intolerances
        } = user;

        gender = _getGenderLetter(gender_id);

        age = (
            birthday
            && moment().diff(moment(birthday), 'years')
        ) || 0;

        foodPreference = food_preference_id || clonedProfile.foodPreference || 1;
        foodPathologies = pathologies.map(({ id }) => id);
        foodAllergies = allergies.map(({ id }) => id);
        foodIntolerances = intolerances.map(({ id }) => id);
    }

    return {
        ...clonedProfile,
        foodPreference,
        age,
        gender,
        foodPathologies,
        foodAllergies,
        foodIntolerances
    };
};


/**
 * Set language by id
 * @param {number} langId
 */
const setLangById = (langId) => {
  const selectedLang = languages.find(({ id }) => id === Number(langId));

  if (selectedLang) {
    _setLanguage(selectedLang);
  } else {
    setLangByCode();
  }
};


/**
 * Set language by code
 * @param {string} langCode [Two characters]
 */
const setLangByCode = (langCode = 'en') => {
  const selectedLang = languages.find(({ code }) => code === langCode);

  if (selectedLang) {
    _setLanguage(selectedLang);
  } else {
    setLangByCode();
  }
};


const getCoupon = () => {
  return localStorage.getItem('coupon');
};

const setCoupon = (coupon) => {
  localStorage.setItem('coupon', coupon);
};


function setWithExpiry(key, value, ttl) {
	const now = new Date()

	// `item` is an object which contains the original value
	// as well as the time when it's supposed to expire
	const item = {
		value: value,
		expiry: now.getTime() + ttl,
	}
	localStorage.setItem(key, JSON.stringify(item))
}

function getWithExpiry(key) {
	const itemStr = localStorage.getItem(key)
	// if the item doesn't exist, return null
	if (!itemStr) {
		return null
	}
	const item = JSON.parse(itemStr)
	const now = new Date()
	// compare the expiry time of the item with the current time
	if (now.getTime() > item.expiry) {
		// If the item is expired, delete the item from storage
		// and return null
		localStorage.removeItem(key)
		return null
	}
	return item.value
}

function isProfileSelectionExpired(ttl =  null) {
    if (ttl?.createdAt?.length > 0) { 
        const duration = ttl?.duration        
        const dateTTL = moment(ttl?.createdAt).add(duration, 'seconds');

        return moment().isAfter(dateTTL)
    }

    return false
}

export {
    deleteSession,
    setLangByCode,
    setLangById,
    getCoupon,
    setCoupon,
    setWithExpiry,
    getWithExpiry,
    getNutritionProfile,
    isProfileSelectionExpired
};
